import service from '@/utils/request';

//获取tempConfig列表
export var getTempList = function getTempList(params) {
  return service({
    url: "/xcpOpsManager/tempConfig/getList",
    method: 'get',
    params: params
  });
};

//保存当前模板
export var createTemp = function createTemp(data) {
  return service({
    url: "/xcpOpsManager/tempConfig/create",
    method: 'post',
    data: data
  });
};
//覆盖当前模板
export var updateTemp = function updateTemp(data) {
  return service({
    url: "/xcpOpsManager/tempConfig/update",
    method: 'post',
    data: data
  });
};

//删除当前模板
export var deleteTemp = function deleteTemp(data) {
  return service({
    url: "/xcpOpsManager/tempConfig/delete",
    method: 'post',
    data: data
  });
};

//id查询TempConfig
export var getInfoByID = function getInfoByID(params) {
  return service({
    url: "/xcpOpsManager/tempConfig/first",
    method: 'get',
    params: params
  });
};